import { useEffect } from 'react';//removed warning
import { connect } from 'react-redux';
import secureStorage from './../../config/encrypt';
import ls from "local-storage";//removed warning
import { useNavigate } from 'react-router-dom';


const Logout = (props) => {
    const historyLead = useNavigate();
    useEffect(() => {
        ls.set('logged_data', {});
        ls.set('login_email', "");
        ls.set('tenant', "");
        window.sessionStorage.setItem("login_tenant", "")
        window.sessionStorage.setItem('login_logged_data', {})
        window.sessionStorage.setItem('login_email', "")
        secureStorage.removeItem('loginUserInfo');
        props.updateStateIntoRedux('LOGOUT_USER', '');
        historyLead("/login")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ('')
}

const mapDispatchToProps = dispatch => {
    return {
        updateStateIntoRedux: (actionType, stateData) => dispatch({ type: actionType, componentState: stateData })
    }
}

export default connect(null, mapDispatchToProps)(Logout);